document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('[data-gallery-track]');
  const slides = Array.from(document.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
  const prev = document.querySelector('[data-gallery-prev]');
  const next = document.querySelector('[data-gallery-next]');
  const count = document.querySelector('[data-gallery-count]');
  let active = 0;
  const showImage = index => {
    if (!track || !slides.length) return;
    active = Math.max(0, Math.min(index, slides.length - 1));
    track.style.setProperty('--gallery-offset', `${-active * 100}%`);
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === active);
      if (i === active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    const rail = document.querySelector('[data-gallery-thumbs]');
    const selected = thumbs[active];
    if (rail && selected && rail.scrollWidth > rail.clientWidth) {
      rail.scrollTo({left: Math.max(0, selected.offsetLeft - rail.offsetLeft - (rail.clientWidth - selected.clientWidth) / 2), behavior: 'auto'});
    }
    if (count) count.textContent = `${active + 1} / ${slides.length}`;
    if (prev) prev.disabled = active === 0;
    if (next) next.disabled = active === slides.length - 1;
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));
  if (prev) prev.addEventListener('click', () => showImage(active - 1));
  if (next) next.addEventListener('click', () => showImage(active + 1));
  if (track) {
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let start;
    track.addEventListener('touchstart', event => {
      start = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
    }, {passive: true});
    track.addEventListener('touchend', event => {
      if (!start || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - start.x;
      const dy = event.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(active + (dx < 0 ? 1 : -1));
      start = null;
    }, {passive: true});
    track.addEventListener('touchcancel', () => {start = null;}, {passive: true});
    showImage(0);
  }
  const form = document.querySelector('.pdp-form');
  if (!form) return;
  const select = form.querySelector('.variant-select');
  const button = form.querySelector('[data-add]');
  const message = form.querySelector('[data-msg]');
  const price = document.querySelector('[data-price]');
  const normal = text => text.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const aliases = {
    'oatmeal heather': ['oatmeal', 'grey', 'gray'], 'sandshell': ['sandshell', 'cream', 'sand', 'beige'],
    'lilac': ['lilac', 'lavender'], 'white': ['white'], 'royal': ['royal', 'blue'],
    'royal blue': ['royal', 'blue'], 'natural': ['natural', 'cream'], 'forest green': ['forest', 'green'],
    'black': ['black'], 'ash': ['ash', 'grey', 'gray']
  };
  const showColour = option => {
    const checked = Array.from(form.querySelectorAll('.pdp-options input:checked'));
    const colour = checked.find(input => /colou?r/i.test(input.name));
    const words = colour ? (aliases[normal(colour.value)] || [normal(colour.value)]) : [];
    const matching = slides.map((slide, index) => ({slide, index, alt: normal(slide.dataset.imageAlt || '')}))
      .filter(item => words.some(word => (` ${item.alt} `).includes(` ${word} `)));
    const linked = slides.findIndex(slide => slide.dataset.imageId === option.dataset.imageId);
    let target = -1;
    if (matching.length) {
      target = (matching.find(item => item.index === linked) || matching.find(item => item.alt.includes('front') && !item.alt.includes('cover')) || matching.find(item => !item.alt.includes('cover')) || matching[0]).index;
    } else if (linked >= 0 && linked !== 0) target = linked;
    if (target >= 0) showImage(target);
  };
  const sync = changeImage => {
    const chosen = Array.from(form.querySelectorAll('.pdp-options input:checked')).map(input => input.value).join(' / ');
    const option = Array.from(select.options).find(item => item.dataset.title === chosen) || (form.querySelector('.pdp-options input') ? null : select.selectedOptions[0]);
    if (changeImage) showColour(option || {dataset: {}});
    if (!option) {
      button.disabled = true; button.textContent = 'Not available';
      message.textContent = 'That combination is not made. Try another colour or size.';
      return;
    }
    select.value = option.value;
    if (price) price.textContent = option.dataset.price;
    button.disabled = option.disabled;
    button.textContent = option.disabled ? 'Sold out' : 'Add to bag';
    message.textContent = '';
  };
  form.querySelectorAll('.pdp-options input').forEach(input => input.addEventListener('change', () => sync(true)));
  sync(false);
});
